export default "__VITE_ASSET__c_WSbr7J__"